import { useEffect } from 'react';
import type { EditActionStatus } from '../stores/use-edit-action-store';

export function useReviewKeyboardShortcuts(
  status: EditActionStatus | string,
  onAccept: () => void,
  onDiscard: () => void,
): void {
  useEffect(() => {
    if (status !== 'review') return;

    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        onAccept();
      } else if (e.key === 'Escape') {
        e.preventDefault();
        onDiscard();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [status, onAccept, onDiscard]);
}
